<template>

  <div class="content-wrap">
    <div class="search-wrap">
      <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="회사명">
              <template #end="{id}">
                <ElInput :id="id" v-model="state.searchParams.cmp_nm" @inputKeyupEnter="onSearch"/>
              </template>

            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="사업부명">
              <template #end="{id}">
                <ElInput :id="id" v-model="state.searchParams.cmp_dvsn_nm" @inputKeyupEnter="onSearch"/>
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="이름">
              <template #end="{id}">
                <ElInput :id="id" v-model="state.searchParams.mngr_nm" @inputKeyupEnter="onSearch"/>
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="사업자번호">
              <template #end="{id}">
                <ElInput :id="id" ref="businessNoRef" v-model="state.searchParams.business_no" @inputKeyupEnter="onSearch" @update:modelValue="bizNoFormat"/>
              </template>
            </ElLabel>

          </div>
        </div>
      </div>
    </div>
    <div class="search-detail-wrap"></div>

    <div class="text-end py-2">
      <ElButton type="search" @buttonClick="onSearch()">
        검색
      </ElButton>
    </div>

    <div class="d-flex justify-content-between">
      <div></div>
      <div class="table-btn-group">
        <ElButton type="excelDownload" @buttonClick="excelDown()">
          엑셀다운
        </ElButton>
      </div>
    </div>
    <!--그리드 영역-->
    <div class="table-responsive table-list">
      <DataTable 
        :value="state.gridRowData" 
        paginator :rows="20"
        :rowsPerPageOptions="[10, 20, 50, 100, 200]" 
        selectionMode="single"
        @rowSelect="onRowSelect" 
        removableSort
      >
        <template #empty>
          <div class="center">데이터가 존재하지 않습니다.</div>
        </template>
        <Column>
          <template #header>
              <ElCheckbox v-model="allCheck"/>
          </template>
          <template #body="{ data }">
              <ElCheckbox 
              v-model="state.selectedRow" 
              :value="data"
              />
          </template>
        </Column>
        <Column>
          <template #header>
            <ElButton
                  type='bookmarkS'
                  disabled
            ></ElButton>
          </template>
          <template #body="{ data }">
            <ElButton
                    type='bookmarkS'
                    disabled
                    :active="data.bkmark_yn == 'Y'"
              ></ElButton>
          </template>
        </Column>

        <Column v-for="manager of state.gridColumn" :field="manager.field" :header="manager.headerName"
          :style="manager.style">
          <template #body="{data,field}">
            <div 
            v-if="field == 'cmp_nm'||field == 'cmp_dvsn_nm'"
            style="width: 150px;text-overflow:ellipsis; overflow:hidden; white-space:nowrap;"
            :title="data[field]"
            >
              {{ data[field] }}
            </div> 
            <span v-else-if="field =='mngr_nm'" v-bind:title="data.mngr_nm">{{ getSummaryData(data.mngr_nm) }}</span>
            <span v-else-if="field =='postion'"  v-bind:title="data.postion">{{ getSummaryData(data.postion) }}</span>
            <span v-else-if="field =='depart_nm'"  v-bind:title="data.depart_nm">{{ getSummaryData(data.depart_nm) }}</span>
            <span v-else>{{ data[field] }}</span>
          </template>
        </Column>
      </DataTable>
    </div>

    <div class="text-end py-3">
      <ElButton v-if="canUpdate" type="primary" @buttonClick="moveToPage('MSH_SR_001')">
        신규등록
      </ElButton>
      <ElButton type="primary" @buttonClick="shareToUser()">공유하기</ElButton>
    </div>
  </div>
   <!-- 메일발송 모달 (1.컴포넌트) -->
   <EmailSendModal ref="emailSendModalRef" />
  <ExcelManage v-show="false" ref="excelManageRef" />
</template>

<script setup>
import { reactive, ref, onBeforeMount, computed } from "vue";
import ExcelManage from "@/components/common/MCO_EX_001.vue";

import DataTable from "primevue/datatable";
import Column from "primevue/column";
import vueRouterCmn from "@/js/vueRouterCmn";
import common from "@/js/common";
import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { mngList } from '@/api/mng'
import EmailSendModal from "@/components/common/modal/EmailSendModal.vue"; 
const emailSendModalRef = ref();
const excelManageRef = ref();
const businessNoRef = ref();

onBeforeMount(() => {
  onSearch();
});

const canUpdate = computed(()=>{
  return common.checkAccessAuth('M004M001')
})

const state = reactive({
  selectedRow: [],
  gridColumn: [
    { headerName: "회사명", field: "cmp_nm", style: { minWidth: '150px' } },
    { headerName: "사업부명", field: "cmp_dvsn_nm", style: { minWidth: '150px' } },
    { headerName: "이름", field: "mngr_nm", style:{textAlign : 'center',minWidth:'60px'} },
    { headerName: "사업자번호", field: "business_no", style: { minWidth: '200px' } },
    { headerName: "직급", field: "postion", style: { minWidth: '100px' } },
    { headerName: "부서", field: "depart_nm", style: { minWidth: '100px' } },
    { headerName: "휴대폰번호", field: "mobile", style: { minWidth: '150px' } },
    { headerName: "이메일", field: "email", style: { minWidth: '200px' } }
    
  ],
  excelGridColumn: [
    { headerName: "즐겨찾기", field: "bkmark_yn"},
    { headerName: "회사명", field: "cmp_nm"},
    { headerName: "사업부명", field: "cmp_dvsn_nm"},
    { headerName: "이름", field: "mngr_nm"},
    { headerName: "사업자번호", field: "business_no"},
    { headerName: "직급", field: "postion"},
    { headerName: "부서", field: "depart_nm"},
    { headerName: "휴대폰번호", field: "mobile"},
    { headerName: "이메일", field: "email"}
    
  ],
  gridRowData: [],
  searchParams: {
    cmp_nm: "",
    cmp_dvsn_nm: "",
    business_no: "",
    mngr_nm: "",
    page_count: 1,
    unit_count: 100000,
  },
});

const allCheck = computed({
  get() {
    return state.gridRowData.length === state.selectedRow.length;
  },
  set(newValue) {
    state.selectedRow = newValue
      ? state.gridRowData.map((item) => {
        return item;
      })
      : [];
  },
});

const getSummaryData = (item) => {

let summaryData = item.length > 6 ? item.slice(0, 6) + " ..." : item;

return summaryData
}


//사업자번호 형식 체크
const bizNoFormat = (no) => {
  no = common.checkOnlyNumber(no)
  state.searchParams.business_no = common.bizNoFormat(no);
  businessNoRef.value.input.value = common.bizNoFormat(no);
};


const onSearch = async () => {
  try {
    setIsLoading(true)
    const res = await mngList(state.searchParams)
    state.gridRowData = res.rtn.map((item, index) => {
      item.index = index + 1
      return item
    })
  } catch (err) {
    console.error("담당자 조회 error", err)
    alert("담당자 조회 에러");
  } finally {
    setIsLoading(false)
  }
};

const excelDown = () => {
  let fileNm = "담당자 리스트";
  let header = [...state.excelGridColumn];
  let dataList = state.gridRowData;
  if (state.selectedRow?.length > 0) {
    dataList = state.selectedRow
  }

  excelManageRef.value.excelDownload(fileNm, header, dataList);
};

//공유하기
const shareToUser = () => {
  openEmailSend();
}


/** 메일발송 모달 (3.팝업오픈) */
const openEmailSend = () => {
  //메일정보 초기값
  const emailParams = {
    call_prgm_id : 'MSH_SR_002',
    call_prgm_nm : '이벤트 조회',
    receiver_ids : '',
    receiver_nms : '',
    title : '이벤트 정보 공유드립니다.',
    content : makeEmailContent()
  };

  emailSendModalRef.value.openEmailModal(emailParams);
};

/** 메일발송 모달 (4.메일내용) */
const makeEmailContent = () => {
  //선택된 담당자의 목록
    //메일 내용 만들기
    let content = '';
    for (let manager of state.selectedRow) {
      content += `<b>${manager.cmp_nm} / ${manager.cmp_dvsn_nm}</b> 이름: ${manager.mngr_nm} 사업자번호: ${manager.business_no}, 직급: ${manager.postion}, 부서: ${manager.depart_nm}, 휴대폰번호: ${manager.mobile}, 이메일: ${manager.email}<br/>`;
    }
    return content;
  
}

const moveToPage = (routerName) => {
  vueRouterCmn.routerPush(routerName);
};

const onRowSelect = (event) => {
  if(canUpdate.value){
    vueRouterCmn.routerPush("MSH_SR_003", { mng_seq: event.data.mng_seq });
  }else{
    vueRouterCmn.routerPush("MSH_SR_004", { mng_seq: event.data.mng_seq });
  }
};
</script>
